<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'App',
        methods: {
            // 关闭窗口之前执行
            beforeunloadHandler() {
                this.beforeUnload_time = new Date().getTime();
            },
            unloadHandler() {
                this.gap_time = new Date().getTime() - this.beforeUnload_time;
                if (this.gap_time <= 5) {
                    localStorage.removeItem('userTK');
                    localStorage.removeItem('userName')
                    localStorage.removeItem('userId')
                }
            },
            //App.vue
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            }
        },
        unmounted() { //vue可换为destroyed()生命周期，不过这个也可以用
            // 移除监听
            window.removeEventListener("beforeunload", () => this.beforeunloadHandler());
            window.removeEventListener("unload", () => this.unloadHandler());
        },
        created() {
            if (this._isMobile()) {
                sessionStorage.setItem('statusPC', '0')
            } else {
                sessionStorage.setItem('statusPC', '1')
            }
        },
        mounted() {
            // 监听浏览器关闭
            window.addEventListener("beforeunload", () => this.beforeunloadHandler());
            window.addEventListener("unload", () => this.unloadHandler());
        }
    }
</script>

<style>
    * {
        margin: 0;
        padding: 0;
    }

    body,
    html {
        margin: 0;
        padding: 0;
    }
</style>